import{fetchAuthSession as e}from"aws-amplify/auth";async function t(){try{await e({forceRefresh:!0})}catch(e){console.error(`Error refreshing auth token:`,e)}}export{t as refreshAuthToken};
//# sourceMappingURL=refresh-auth-token.mjs.map